"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var Sidebar_1 = require("../Sidebar");
var SidebarProvider = (function (_super) {
    __extends(SidebarProvider, _super);
    function SidebarProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggleSidebar = function () {
            _this.setState(function (prevState) { return ({
                expanded: !prevState.expanded
            }); });
        };
        _this.makeContext = function () {
            var themeRtl = _this.context.rtl;
            var rtl = _this.props.rtl;
            return __assign(__assign({}, _this.state), { toggleSidebar: _this.toggleSidebar, rtl: themeRtl || rtl });
        };
        _this.state = {
            expanded: _this.props.expandedByDefault,
            rtl: _this.context.rtl || _this.props.rtl
        };
        return _this;
    }
    SidebarProvider.prototype.render = function () {
        var children = this.props.children;
        var value = this.makeContext();
        return (react_1.default.createElement(Sidebar_1.SidebarContext.Provider, { value: value }, children));
    };
    SidebarProvider.contextType = styled_components_1.ThemeContext;
    SidebarProvider.defaultProps = {
        expandedByDefault: false
    };
    return SidebarProvider;
}(react_1.Component));
exports.default = SidebarProvider;
//# sourceMappingURL=index.js.map